module.exports = __webpack_public_path__ + "static/media/button_gradient.cc883b9e.jpg";